import { createStore } from 'vuex'
import getters from './getters'
import User from './modules/user.js'

export default createStore({
    modules: {
        User,
    },
    getters
})